module.exports = __webpack_public_path__ + "img/img_gift3.3c1ce91e.png";